<template>
  <div>
    <a-row>
      <a-col :span="24">
        <a-card style="margin: 10px 20px 10px 20px; padding: 20px">
          <keytype-chart ref="keytypeChart"></keytype-chart>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { KeytypeChart } from "./components/index.js";
import { getChartByKeyType } from "@/api/charts.js";
export default {
  components: {
    KeytypeChart,
  },
  data() {
    return {
      receivedId: null,
      receivedDm: null,
      wcikeyTypeData: [],
      tkkeyTypeData: [],
    };
  },
  created() {
    this.receivedId = this.$route.query.id || "";
    this.receivedDm = this.$route.query.dm || "";
    this.GetData();
  },
  methods: {
    GetData() {
      getChartByKeyType(this.receivedId,this.receivedDm).then((res) => {
        if (res.code == 0) {
          this.wcikeyTypeData = res.data.wciInfos;
          this.tkkeyTypeData = res.data.tkInfos;
          this.$nextTick(() => {
            this.$refs["keytypeChart"].SetData(
              this.wcikeyTypeData,
              this.tkkeyTypeData,
              res.msg
            );
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
